import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import he from './locales/he.json';
import ar from './locales/ar.json';
import ru from './locales/ru.json';

const resources = {
  en: {
    translation: en,
  },
  he: {
    translation: he,
  },
  ar: {
    translation: ar,
  },
  ru: {
    translation: ru,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    // Ensure we use short codes (e.g., 'en' instead of 'en-US')
    lng: localStorage.getItem('language') || 'he',
    fallbackLng: ['he', 'en'],
    supportedLngs: ['he', 'en', 'ar', 'ru'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
